<template>
  <div>
    <Datatable ref="datatable" route="/client/liste" :fields="fields" :data_filters="filters" titre="Liste des prospects" :sort="sort">      
      <template #action>
        <b-button v-if="$api.acl(19)" variant="light-primary" class="mr-2 btn-icon" size="md" @click="$refs.modalDistribution.show()">
          <i class="fas fa-user text-white fa-size"></i>
        </b-button>                
        <b-button v-if="$api.acl(6)" variant="light-success" class="btn-icon" v-b-tooltip.hover title="Exporter votre rechercher" @click="toCSV()">
          <i class="fa fa-file-excel fa-size"></i>
        </b-button>
        <b-button variant="light-info" class="btn-icon ml-2" v-b-tooltip.hover title="Imprimer votre rechercher" @click="print()">
          <i class="fa fa-print fa-size"></i>
        </b-button>
        <b-dropdown v-if="$api.acl(7)" variant="light-danger" right v-b-tooltip.hover title="Envoyer un mail" no-caret class="ml-2" toggle-class="btn-icon" size="md">
          <template #button-content>
            <i class="fas" :class="loadMail ? 'fa-spin fa-spinner fa-size' : 'fa-envelope fa-size'"></i>
          </template>
          <b-dropdown-item v-for="(m,i) in mails" :key="i"  @click="tplMail = m.id; $refs.mailTpl.show()">{{m.titre}}</b-dropdown-item>
        </b-dropdown>
        <!-- <b-dropdown v-if="$api.acl(8)" variant="success" right v-b-tooltip.hover title="Creer un nouveau prospect" no-caret class="ml-2" toggle-class="btn-icon" size="md">
          <template #button-content>
            <i class="fas fa-plus"></i>
          </template>
          <b-dropdown-item @click="createForm = 'Appel'; $refs.modalCreateForm.show()">Appels entrant</b-dropdown-item>
          <b-dropdown-item @click="createForm = 'Agence'; $refs.modalCreateForm.show()">En agence</b-dropdown-item>
          <b-dropdown-item v-if="$api.acl(32)" href="/#/prospect/nouveau" button>Autre</b-dropdown-item>
        </b-dropdown> -->
        <b-button v-if="$api.acl(8)" v-b-tooltip.hover size="md" title="Creer un nouveau prospect" variant="success" class="btn-icon ml-2" @click="$refs.modalCreateForm.show()"><i class="fas fa-plus"></i></b-button>
        <b-button v-if="$api.acl(32)" v-b-tooltip.hover size="md" title="Creer un nouveau prospect" variant="dark" class="btn-icon ml-2" href="/#/prospect/nouveau"><i class="fas fa-plus"></i></b-button>
      </template>      
      <template #cell(id)="data">
        <router-link :to="'/prospect/detail/'+data.value">{{data.value}}</router-link>
      </template>
      <template #cell(nom)="data">
        <router-link :to="'/prospect/detail/'+data.item.id">{{ data.value }} {{ data.item.prenom }}</router-link>
      </template>
      <template #cell(action)="data">
        <b-form-checkbox v-model="selected" :key="data.item.id" :value="data.item.id" size="lg" inline >
          <i class="fa fa-star text-warning" v-if="checkSelect(data.item.id)"></i>
        </b-form-checkbox>              
      </template>              
      <template #cell(telephone_1)="data">
        <Telephone v-model="data.item.telephone_1" :edit="false" />
      </template>
      <template #cell(email)="data">
        <a :href="`mailto:${data.value}`">{{ data.value }}</a>
      </template>      
      <template #cell(regime_id)="data">
        <span>{{ $api.getParam('Regime', data.value).titre }}</span>
      </template>
      <template #cell(user_id)="data">
        <span>{{ $api.getParam('User', data.value).titre }}</span>
      </template>
      <template #cell(source_id)="data">
        <span>{{ $api.getParam('Source', data.value).titre }}</span>
      </template>      
      <template #cell(transformation_id)="data">
        <span>{{ $api.getParam('ClientTransformation', data.value).titre }}</span>
      </template>      
      <template #cell(date_effet)="data">
        {{ $api.moment(data.value).format("DD/MM/YYYY") }}
      </template>      
      <template #cell(date_create)="data">
        {{$api.timestampToDate(data.value)}}
      </template>      
      <template #cell(date_update)="data">
        {{$api.timestampToDate(data.value)}}
      </template>      
      <template #cell(status_id)="data">
        <b-dropdown v-b-tooltip.hover title="Changer le statut du prospect" no-caret  :variant="$api.p('ClientStatus', data.value).color" size="md">
          <template #button-content>
            {{ $api.p('ClientStatus', data.value).titre }} <i class="ml-2 fas fa-chevron-down"></i>
          </template>
          <b-dropdown-item v-for="(s,i) in $api.params.ClientStatus" :key="i" :disabled="$api.params.StatusLock.prospect_lock.includes(data.value)" :active="data.value === s.id" @click="changeStatus(data.item, s.id)">{{s.titre}}</b-dropdown-item>
        </b-dropdown>        
      </template>
    </Datatable>
    <b-modal id="mailTpl" ref="mailTpl" hide-footer title="Envoi de mail en masse" size="lg" centered>
      <b-card-text v-if="tplMail != null">Vous etes sur le point d'envoyer le mail <strong>"{{ $api.p('Template', tplMail).titre }}"</strong> à <strong>{{ $refs.datatable.datatable.totalRow }}</strong> contacts</b-card-text>
      <div class="d-block text-center mt-3">
        <b-button variant="light-primary" :class="loadMail ? 'btn-icon' : ''" @click="sendMails()">
          <span v-if="loadMail === false" class="text-white">Envoyer</span>
          <i v-else class="fa fa-spin fa-spinner"></i>
        </b-button>
      </div>
    </b-modal>
    <b-modal id="modalDistribution" ref="modalDistribution" hide-footer title="Envoi des prospects" size="lg" centered>
      <b-card-text>Vous etes sur le point d'envoyer <strong>{{ selected.length }} prospects</strong> </b-card-text>
      <b-form-group label="Commercial:">
        <Input type="select-model" :options="$api.params.User" v-model="user_id"/>
      </b-form-group>
      <div class="d-block text-center mt-3">
        <b-button variant="light-primary" :class="loadDistribution ? 'btn-icon' : ''" @click="sendLeads()">
          <span v-if="loadDistribution === false" class="text-white">Envoyer</span>
          <i v-else class="fa fa-spin fa-spinner"></i>
        </b-button>
      </div>
    </b-modal>    
    <b-modal id="modalCreateForm" ref="modalCreateForm" hide-footer title="Envoi lien création de prospect" size="lg" centered @hidden="resetForm">
      <b-form @submit.prevent="handleSubmit" novalidate>
        <b-row>          
          <b-col md="4">
            <b-form-group label="Civilité" label-for="field-civilite">
              <b-form-select id="field-civilite" v-model="tmpLead.civilite" :options="civiliteOptions" :state="validateField('civilite')"></b-form-select>
              <b-form-invalid-feedback>Veuillez sélectionner une civilité.</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <!-- Nom -->
          <b-col md="4">
            <b-form-group label="Nom" label-for="field-nom">
              <b-form-input id="field-nom" v-model.trim="tmpLead.nom" :state="validateField('nom')" placeholder="Nom de famille"></b-form-input>
              <b-form-invalid-feedback>Le nom est requis.</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <!-- Prénom -->
          <b-col md="4">
            <b-form-group label="Prénom" label-for="field-prenom">
              <b-form-input id="field-prenom" v-model.trim="tmpLead.prenom" :state="validateField('prenom')" placeholder="Prénom"></b-form-input>
              <b-form-invalid-feedback>Le prénom est requis.</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <!-- Email -->
          <b-col md="5">
            <b-form-group label="Email" label-for="field-email">
              <b-form-input id="field-email" v-model.trim="tmpLead.email" type="email" placeholder="exemple@domaine.com"></b-form-input>
            </b-form-group>
          </b-col>
          <!-- Téléphone -->
          <b-col md="4">
            <b-form-group label="Téléphone" label-for="field-telephone">
              <b-form-input id="field-telephone" v-model.trim="tmpLead.telephone_1" type="tel" :state="validateField('telephone_1')" placeholder="06 00 00 00 00"></b-form-input>
              <b-form-invalid-feedback>{{ phoneError }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <!-- Source -->
          <b-col md="3">
            <b-form-group label="Source" :state="validateField('source_id')">
              <b-form-radio-group id="radio-group-source" v-model="tmpLead.source_id" :state="validateField('source_id')" stacked>
                <b-form-radio :value="39">Agence</b-form-radio>
                <b-form-radio :value="13">Appel entrant</b-form-radio>
                <b-form-radio :value="4">Parrainage</b-form-radio>
                <b-form-radio :value="15">Resiliation externe</b-form-radio>
              </b-form-radio-group>
              <b-form-invalid-feedback :state="validateField('source_id')">
                Veuillez sélectionner une source.
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <!-- Parrain / Marraine (conditionnel) -->
          <b-col md="4" v-if="tmpLead.source_id === 4">
            <b-form-group label="Parrain / Marraine" label-for="field-parrain">
              <b-form-input id="field-parrain" v-model.trim="tmpLead.parrain" :state="validateField('parrain')" placeholder="Nom du parrain ou de la marraine"></b-form-input>
              <b-form-invalid-feedback>Le nom du parrain / de la marraine est requis.</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Alerte erreur globale -->
        <b-alert :show="submitted && !isFormValid" variant="danger" class="mt-2">
          <i class="fas fa-exclamation-triangle mr-2 text-white"></i>
          Veuillez corriger les champs invalides avant de continuer.
        </b-alert>
        <!-- Boutons de soumission -->
        <div class="d-block text-center mt-3">
          <template v-if="tmpLead.source_id !== 4">
            <b-button type="submit" variant="success">
              <i class="fas fa-check mr-1"></i> Créer
            </b-button>
          </template>
          <template v-else>
            <b-button v-if="isValidEmail(tmpLead.email)" type="submit" variant="success" @click="submitAction = 'email'">
              <i class="fas fa-envelope mr-1"></i> Envoyé par email
            </b-button>
            <b-button type="submit" variant="outline-success" class="ml-2" @click="submitAction = 'sms'">
              <i class="fas fa-sms mr-1"></i> Envoyé par SMS
            </b-button>
          </template>
        </div>
      </b-form>
    </b-modal>
    <Script buttonVariant="light-danger"></Script>
  </div>
</template>
<script>
import Datatable from '@/components/Datatable';
import Telephone from '@/components/Telephone';
import Input from '@/components/InputForm';
import Script from '@/components/Script.vue';

export default {
  name: "ClientListe",
  components: {
    Datatable,Telephone, Input, Script
  },
  watch:{    
  },
  data(){ 
    var fields = [{key: 'id', label: 'Ref', sortable:true,}]
    if(this.$api.acl(19)){
      fields.push({ key: 'action', label: 'Action', sortable:false, });
    }
    fields = fields.concat([ 
      { key: 'nom', label: 'Nom', sortable:true, }, 
      { key: 'telephone_1', label: 'Telephone 1', sortable:false, }, 
      { key: 'email', label: 'Email', sortable:false, }, 
      { key: 'date_effet', label: 'Date effet', sortable:false, }, 
      { key: 'user_id', label: 'Commercial', sortable:true, }, 
      { key: 'source_id', label: 'Source', sortable:true, }, 
      { key: 'transformation_id', label: 'Transfo', sortable:true, }, 
      { key: 'date_create', label: 'Creation', sortable:true, }, 
      { key: 'date_update', label: 'Modification', sortable:true, }, 
      { key: 'status_id', label: 'Statut', sortable:true, }, 
    ]);
    return{
      filters:{},
      fields: fields,      
      sort:{
        key: 'date_update',
        value: 'DESC'
      },
      loadMail:false,
      tplMail: null,
      selected:[],
      loadDistribution: false,
      user_id: null,     
      createForm: null,
      loadSendForm: false,
      tmpLead:{
        id:null,
        civilite: null,
        nom: null,
        prenom:null,
        email: null,
        telephone_1: null,
        source_id: null,
        parrain: null
      },
      submitted: false,
      submitAction: null,
      civiliteOptions: [
        { value: null, text: '-- Choisir --', disabled: true },
        { value: 'Mr', text: 'Mr' },
        { value: 'Mme', text: 'Mme' },
      ],
    }
  },
  computed:{
    mails(){
      var type = "ClientMail";
      return this.$api.params.Template.filter(t => t.type === type);
    },    
    formAgence(){
      let params = {
        "titre":"Demande de devis",
        "user_id": this.$api.user.id,
        "user_telephone": this.$api.user.telephone,
        "source_id":39,
        "form_complet":false,
        "nom": this.formLead.nom,
        "prenom": this.formLead.prenom,
        "telephone_1": this.formLead.telephone_1,
        "email": this.formLead.email
      }
      return `${this.$api.url.app}/#/campagne/${btoa(JSON.stringify(params))}`
    },
    emailError() {
      if (!this.tmpLead.email) return "L'email est requis.";
      if (!this.isValidEmail(this.tmpLead.email)) return "L'adresse email n'est pas valide.";
      return '';
    },

    phoneError() {
      if (!this.tmpLead.telephone_1) return 'Le téléphone est requis.';
      if (!this.isValidPhone(this.tmpLead.telephone_1)) return 'Le numéro de téléphone n\'est pas valide.';
      return '';
    },

    isFormValid() {
      return (
        !!this.tmpLead.civilite &&
        !!this.tmpLead.nom &&
        !!this.tmpLead.prenom &&        
        this.isValidPhone(this.tmpLead.telephone_1) &&
        this.tmpLead.source_id !== null &&
        (this.tmpLead.source_id !== 4 || !!this.tmpLead.parrain)
      );
    },
  },
  methods: {
    changeStatus(data, status){
      data.status_id = status;
      var params = {
        id: data.id,
        status_id: status
      }
      this.$api.ajax('/client/create', params, res => {
        if(res.status === true){
          this.$bvToast.toast('Sauvegarder', {
            title: 'Sauvegarder',
            variant: 'success',
            solid: true
          });          
        }
      })
    },
    sendMails(){
      if(this.loadMail === true){
        return true;
      }
      this.loadMail = true;
      var params = {
        tpl_id: this.tplMail,
        params: this.$refs.datatable.params
      }
      this.$api.ajax('/client/mails', params, res => {
        if(res.status === true){
          this.$refs.mailTpl.hide();
          this.$bvToast.toast("L'envoi c'est correctement fini", {
            title: 'Sauvegarder',
            variant: 'success',
            solid: true
          });
        }
        this.loadMail = false;
      });
    },
    print(){
      window.print();
    },
    toCSV(){
      var rows = [];
      var title = ['ID','Nom', 'Telephone 1', 'Email', 'Date effet', 'Commercial', 'Source', 'Dae creation', 'Statut'];
      rows.push(title.join(';'));
      this.$refs.datatable.datatable.data.forEach((r) => {
        var tmp = [];
        tmp.push(r.id);
        tmp.push(r.nom);
        tmp.push(r.telephone_1);
        tmp.push(r.email);
        tmp.push(r.date_effet);
        tmp.push(this.$api.p('User', r.user_id).titre);          
        tmp.push(this.$api.p('Source', r.source_id).titre);          
        tmp.push(this.$api.moment(r.date_create * 1000).format("DD/MM/YYYY HH:mm:ss"));
        tmp.push(this.$api.p('ClientStatus', r.status_id).titre);          
        rows.push(tmp.join(';'));        
      });
      rows = rows.join("\n");
      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(rows);
      hiddenElement.target = '_blank';
      hiddenElement.download = 'Export.csv';
      hiddenElement.click();
    },
    checkSelect(lead_id){
      return this.selected.filter(s => s === lead_id).length === 1;
    },
    sendLeads(){
      if(this.loadDistribution === true){
        return false;
      }
      this.loadDistribution = true;
      var params = {
        user_id:this.user_id,
        leads: this.selected
      }
      this.$api.ajax('/client/distribution', params, res => {
        if(res.status === true){          
          this.$bvToast.toast("Les propects on bien ete distribue", {
            title: 'Sauvegarder',
            variant: 'success',
            solid: true
          });
          this.selected = [];
          this.user_id = null;
          this.$refs.datatable.datatableInit();
          this.$refs.modalDistribution.hide();
        }
        this.loadDistribution = false;
      })
    },
    async copyLink(text) {
      if (!text) return
      try {
        // Moderne
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(text)
        } else {
          // Fallback
          const el = document.createElement("textarea")
          el.value = text
          el.setAttribute("readonly", "")
          el.style.position = "absolute"
          el.style.left = "-9999px"
          document.body.appendChild(el)
          el.select()
          document.execCommand("copy")
          document.body.removeChild(el)
        }

        // Notification
        this.$bvToast.toast("Lien copié dans le presse-papier.", {
          title: "Copie réussie",
          variant: "success",
          solid: true,
          autoHideDelay: 2000,
          toaster: "b-toaster-top-right",
        })
      } catch (e) {
        this.$bvToast.toast("Impossible de copier le lien.", {
          title: "Erreur",
          variant: "danger",
          solid: true,
          autoHideDelay: 2500,
          toaster: "b-toaster-top-right",
        })
      }
    },
    sendFormLead(){
      if(this.loadSendForm) return 
      var form = this.$refs.form;
      var fields = form.querySelectorAll("[required='required']");
      var valide = true;
      fields.forEach((item) => {
        if(item.checkValidity() === false){
          item.classList.add("need-validation");
          valide = false;
        }else{          
          item.classList.remove("need-validation");
        };
      });
      if(valide === false){
        this.$bvToast.toast('Merci de remplir tout les champs en rouge', {
          title: 'Champs',
          variant: 'warning',
          solid: true
        });
        this.tabIndex = 0;
        return false;
      }
      const params = {
        ...this.formLead, 
        methode: this.formLead.methode === 0 ? 'mail' : 'sms',
        lien: this.formLead.type === 'Appel' ? this.formAppel : this.formAgence
      }
      this.loadSendForm = true;
      this.$api.ajax('/source/form', params, res => {
        if(res.status){
          this.$bvToast.toast('Le formulaire a bien été envoyé', {
            title: 'Houra !',
            variant: 'success',
            solid: true
          });   
        }
        this.loadSendForm = false;
      })
      
    },
    validateField(field) {
      if (!this.submitted) return null;

      switch (field) {
        case 'civilite':
          return !!this.tmpLead.civilite;
        case 'nom':
          return !!this.tmpLead.nom;
        case 'prenom':
          return !!this.tmpLead.prenom;
        case 'email':
          return this.isValidEmail(this.tmpLead.email);
        case 'telephone_1':
          return this.isValidPhone(this.tmpLead.telephone_1);
        case 'source_id':
          return this.tmpLead.source_id !== null;
        case 'parrain':
          return this.tmpLead.source_id === 4 ? !!this.tmpLead.parrain : null;
        default:
          return null;
      }
    },
    isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },
    isValidPhone(phone) {
      if(!phone){
        return false;
      }
      // Accepte formats FR : 0600000000 / 06 00 00 00 00 / +33600000000
      return /^(\+33|0)[1-9](\s?\d{2}){4}$/.test(phone.replace(/\s/g, ''));
    },
    handleSubmit() {
      this.submitted = true;

      if (!this.isFormValid) return;
      var params = {
        action: this.submitAction,
        lead: this.tmpLead
      }      
      this.$api.ajax('/source/form', params, res => {
        if(res.status){
          if(res.data === 'ok'){
            this.$bvToast.toast('Le message à bien été envoyé', {
              title: 'Envoyé',
              variant: 'success',
              solid: true
            });    
            this.$refs.modalCreateForm.hide();
          }else if(res.data.client_id){
            this.$router.push({path:`/prospect/detail/${res.data.client_id}`})
          }
        }
      })
    },
    resetForm() {
      this.submitted = false;
      this.submitAction = null;
      this.tmpLead = {
        civilite: null,
        nom: '',
        prenom: '',
        email: '',
        telephone_1: '',
        source_id: null,
        parrain: '',
      };
    },
  },
  beforeMount() {
  },
  mounted() {        
  }
}
</script>
<style>
@media print {
  .menu-desktop, #menu-mobile, #header{
    display: none !important;
  }            
}
.need-validation {
  border: solid 2px red;
}
</style>
